import { render, staticRenderFns } from "./TotalizadoresComponent.vue?vue&type=template&id=6b0fb9c0&scoped=true"
import script from "./TotalizadoresComponent.vue?vue&type=script&lang=js"
export * from "./TotalizadoresComponent.vue?vue&type=script&lang=js"
import style0 from "./TotalizadoresComponent.vue?vue&type=style&index=0&id=6b0fb9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0fb9c0",
  null
  
)

export default component.exports